import { commonRequest } from "../../services/ApiCall";
import { Helpers } from "../../services/Helpers";

const baseUrl = `${Helpers.URL()}/api/v2/admin/testimonials`;

export const TestimonialServices = {
  list: async ({ page, limit, searchKey }) => {
    const queryParams = new URLSearchParams();
    queryParams.append("page", page + 1);
    queryParams.append("limit", limit);
    queryParams.append("searchKey", searchKey || "");

    return await commonRequest("get", `${baseUrl}/list?${queryParams.toString()}`, {}, Helpers.token());
  },

  create: async (data) => {
    return await commonRequest("post", baseUrl, data, Helpers.token());
  },

  update: async (id, data) => {
    return await commonRequest("put", `${baseUrl}/${id}`, data, Helpers.token());
  },

  remove: async (id) => {
    return await commonRequest("delete", `${baseUrl}/${id}`, {}, Helpers.token());
  },
};
